module.exports = __webpack_public_path__ + "img/p-details.fc0d5f42.png";